import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DIALOG_TYPES,
  FormFieldIcon,
} from 'components/alf-design';
import { helpCircle } from 'assets/icon';
import flSlide from '../../../assets/img/policy-help/FL.png';
import './Guidance.css';

const dialogWrapperStyle = {
  width: 'min(100%, 800px)',
  maxWidth: 'min(100%, 800px)',
};

const Guidance = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClickOpen = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <FormFieldIcon>
        <div className="guidance-trigger-wrapper">
          <Button
            data-dd-action-name="create_account.policy_number_help.open"
            ariaLabel="policy number help"
            className="guidance-policy-help"
            type="icon"
            htmlType="button"
            onClick={handleClickOpen}
            icon={<img alt="" src={helpCircle} width={14} height={14} />}
          />
        </div>
      </FormFieldIcon>
      <Dialog
        id="guidance"
        type={DIALOG_TYPES.CONTENT}
        show={isOpen}
        onClose={handleClose}
        title="Policy Number Location"
        subtitle="Your policy number can be found on your declaration page."
        ariaLabel="Policy number help"
        wrapperStyle={dialogWrapperStyle}
      >
        <div className="guidance-policy-image-wrapper">
          <img
            src={flSlide}
            alt="Policy Number"
            className="guidance-policy-image"
          />
        </div>
      </Dialog>
    </>
  );
};

Guidance.propTypes = {
  zip: PropTypes.string,
  disabledGuidance: PropTypes.bool,
  setDisabledGuidance: PropTypes.func,
  style: PropTypes.object,
};

export default Guidance;
